import React from 'react'
import { WrapperSection, Title } from './styles'
import { EligibilitySearchContent } from './EligibilitySearchContent'

export const EligibilitySearch = () => {
  return (
    <div>
      <WrapperSection>
        <Title>Check the eligibility & benefits of a member</Title>
      </WrapperSection>
      <EligibilitySearchContent />
    </div>
  )
}
